import React from 'react'
import Icon from '@mui/material/Icon';

const ratings = {

    0 : [
        <Icon key={1}>star_outline</Icon>,
        <Icon key={2}>star_outline</Icon>,
        <Icon key={3}>star_outline</Icon>,
        <Icon key={4}>star_outline</Icon>,
        <Icon key={5}>star_outline</Icon>,
    ],
    1: [
        <Icon color="warning" key={1}>star</Icon>,
        <Icon key={2}>star_outline</Icon>,
        <Icon key={3}>star_outline</Icon>,
        <Icon key={4}>star_outline</Icon>,
        <Icon key={5}>star_outline</Icon>,
    ],
    1.5: [
        <Icon  color="warning" key={1}>star</Icon>,
        <Icon  color="warning" key={2}>star_half</Icon>,
        <Icon key={3}>star_outline</Icon>,
        <Icon key={4}>star_outline</Icon>,
        <Icon key={5}>star_outline</Icon>,
    ],
    2: [
        <Icon  color="warning" key={1}>star</Icon>,
        <Icon  color="warning" key={2}>star</Icon>,
        <Icon key={3}>star_outline</Icon>,
        <Icon key={4}>star_outline</Icon>,
        <Icon key={5}>star_outline</Icon>,
    ],
    2.5: [
        <Icon  color="warning" key={1}>star</Icon>,
        <Icon  color="warning" key={2}>star</Icon>,
        <Icon  color="warning" key={3}>star_half</Icon>,
        <Icon key={4}>star_outline</Icon>,
        <Icon key={5}>star_outline</Icon>,
    ],
    3: [
        <Icon  color="warning" key={1}>star</Icon>,
        <Icon  color="warning" key={2}>star</Icon>,
        <Icon  color="warning" key={3}>star</Icon>,
        <Icon key={4}>star_outline</Icon>,
        <Icon key={5}>star_outline</Icon>,
    ],
    3.5: [
        <Icon  color="warning" key={1}>star</Icon>,
        <Icon  color="warning" key={2}>star</Icon>,
        <Icon  color="warning" key={3}>star</Icon>,
        <Icon  color="warning" key={4}>star_half</Icon>,
        <Icon key={5}>star_outline</Icon>,
    ],
    4: [
        <Icon  color="warning" key={1}>star</Icon>,
        <Icon  color="warning" key={2}>star</Icon>,
        <Icon  color="warning" key={3}>star</Icon>,
        <Icon  color="warning" key={4}>star</Icon>,
        <Icon key={5}>star_outline</Icon>,
    ],
    4.5: [
        <Icon  color="warning" key={1}>star</Icon>,
        <Icon  color="warning" key={2}>star</Icon>,
        <Icon  color="warning" key={3}>star</Icon>,
        <Icon  color="warning" key={4}>star</Icon>,
        <Icon  color="warning" key={5}>star_half</Icon>,
    ],
    5: [
        <Icon  color="warning" key={1}>star</Icon>,
        <Icon  color="warning" key={2}>star</Icon>,
        <Icon  color="warning" key={3}>star</Icon>,
        <Icon  color="warning" key={4}>star</Icon>,
        <Icon  color="warning" key={5}>star</Icon>,
    ],
  };

const Ratings = ({rating}) => <div>{ratings[rating || 0]}</div>

export default Ratings